// extracted by mini-css-extract-plugin
export var addButton = "_5r-d";
export var bullets = "_5r-e";
export var compact = "_5r-2";
export var container = "_5r-j";
export var extendedWarrantyModal = "_5r-f";
export var learn = "_5r-l";
export var learnMore = "_5r-g";
export var offeringOption = "_5r-3";
export var offeringPrice = "_5r-8";
export var offeringSubtitle = "_5r-7";
export var offeringTitle = "_5r-6";
export var offeringsContainer = "_5r-0";
export var pdpTilesBackground = "_5r-n";
export var plan = "_5r-m";
export var regular = "_5r-1";
export var remove = "_5r-k";
export var seeDetailsIcon = "_5r-i";
export var seeDetailsLink = "_5r-h";
export var selectedOption = "_5r-4";
export var shieldIcon = "_5r-b";
export var shieldIconCompact = "_5r-c";
export var subtitle = "_5r-a";
export var title = "_5r-9";
export var unselectedOption = "_5r-5";